import { useParams } from 'react-router-dom';
import React, { useState } from 'react';
import ViewTable from 'app/shared/view-table/view-table';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import {
  copyBuildingQuery,
  deleteBuildingQuery,
  fetchBuildingsQuery,
} from 'app/edozvola/cases/construction-building-procedure/service/construction-building-procedure.queries';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BuildingView } from 'app/edozvola/cases/construction-building-procedure/buildings/model/building.model';
import { TABLE_QUERY_KEYS } from 'app/config/constants';
import { getInvalidRowsForTable } from 'app/shared/util/validation-errors.util';
import { getCaseContext } from 'app/shared/util/context-util';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';

const BuildingTable = ({ setIdBuilding, setReadOnly, variant }) => {
  const { id: uuid } = useParams<{ id: string }>();
  const [idBuildingToDelete, setIdBuildingToDelete] = useState();
  const [deleteModalShown, setDeleteModalShown] = useState(false);
  const { sidebarItemPair } = getCaseContext();

  const invalidRowIds = getInvalidRowsForTable(TABLE_QUERY_KEYS.BUILDINGS_TABLE);

  const { mutate: deleteBuildingMutation, isPending: isDeletingBuilding } = deleteBuildingQuery(variant);
  const { mutate: copyBuildingMutation, isPending: isCopyingBuilding } = copyBuildingQuery(variant);

  const openBuildingForm = (idBuilding: number, readOnly: boolean) => {
    setIdBuilding(idBuilding);
    setReadOnly(readOnly);
  };

  const openDeleteDialog = idToDelete => {
    setIdBuildingToDelete(idToDelete);
    setDeleteModalShown(true);
  };

  const removeBuilding = () => {
    setDeleteModalShown(false);
    deleteBuildingMutation(idBuildingToDelete);
  };

  const renderTableRow = (value: BuildingView, buildingIndex: number, totalItems: number) => {
    return (
      <tr key={buildingIndex} className={invalidRowIds.includes(value.idBuilding) ? 'invalid-table-row' : ''}>
        <td> {value.cbpBuildingPurpose?.split('\n').map((line, i) => <div key={i}>{line}</div>)}</td>
        <td>{value.buildingPurposeAdditionalDescription}</td>
        <td>{value.requirementGroup}</td>
        <td>{value.ibz}</td>
        <td>
          <div className={'actions-container'}>
            {sidebarItemPair?.canView && (
              <TooltipWrapper message={'Pregledaj'}>
                <FontAwesomeIcon icon={'eye'} className={'icon-table'} onClick={() => openBuildingForm(value.idBuilding, true)} />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canEdit && (
              <TooltipWrapper message={'Uredi'}>
                <FontAwesomeIcon
                  icon={'pen-to-square'}
                  className={'icon-table'}
                  onClick={() => openBuildingForm(value.idBuilding, false)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canCopy && (
              <TooltipWrapper message={'Kopiraj'}>
                <FontAwesomeIcon icon={'copy'} className={'icon-table'} onClick={() => copyBuildingMutation(value.idBuilding)} />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canDelete && (
              <TooltipWrapper message={'Obriši'}>
                <FontAwesomeIcon icon={'trash-alt'} className={'icon-table'} onClick={() => openDeleteDialog(value.idBuilding)} />
              </TooltipWrapper>
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ViewTable
        renderTableRow={renderTableRow}
        noDataMessage={'Nema zgrada'}
        initialPaginationColumn={'cbpBuildingPurpose'}
        fetchDataQuery={fetchBuildingsQuery}
        fetchDataProps={[uuid]}
      >
        <ViewTableHeaderColumn renderSort={ false } columnLabels={ ['Vrsta zahvata / Namjena'] } width={ '150px' }/>
        <ViewTableHeaderColumn renderSort={ false } columnLabels={ ['Dodatni opis namjene'] } width={ '150px' }/>
        <ViewTableHeaderColumn renderSort={ false } columnLabels={ ['Skupina prema zahtjevnosti'] } width={ '150px' }/>
        <ViewTableHeaderColumn renderSort={ false } columnLabels={ ['IBZ'] } width={ '100px' }/>
        <ViewTableHeaderColumn renderSort={ false } columnLabels={ ['Akcije'] } width={ '100px' }/>
      </ViewTable>
      <Modal scrollable isOpen={deleteModalShown} size={'lg'} toggle={() => setDeleteModalShown(false)} centered>
        <ModalHeader>
          <span>Brisanje zgrade</span>
        </ModalHeader>
        <ModalBody>
          <div>Jeste li sigurni da želite obrisati podatke?</div>
        </ModalBody>
        <ModalFooter>
          <Button size={'lg'} label="Odustani" outline onClick={() => setDeleteModalShown(false)} />
          <Button size={'lg'} label="Obriši" color={'danger'} onClick={removeBuilding} />
        </ModalFooter>
      </Modal>
    </>
  );
};

export default BuildingTable;
